import React from "react";
import "./css/post-59.css"
import "./css/post-1167.css"
import { useParams } from "react-router-dom";
import NewData from "./NewData";
const Insights = () => {
  const { newName } = useParams(); // Get the service name from the URL
  const service = NewData[newName];
  console.log("service", service); // Get the corresponding service data
  if (!service) {
    return <h2>Service not found</h2>; // Handle case where service is not found
  }
  return (
    <div
      data-elementor-type="cmsmasters_singular"
      className="elementor elementor-59 cmsmasters-location-cmsmasters_singular cmsmasters-header-position-absolute- post-1167 post type-post status-publish format-standard has-post-thumbnail hentry category-payments tag-open-banking tag-payments-navigator"
    >
      <div className="elementor-inner">
        <div className="elementor-section-wrap">
          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-35bd7295 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
            data-id="35bd7295"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-wide">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-eb02893"
                data-id="eb02893"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <section
                    className="elementor-section elementor-inner-section elementor-element elementor-element-430edd3a elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                    data-id="430edd3a"
                    data-element_type="section"
                  >
                    <div className="elementor-container elementor-column-gap-no">
                      <div
                        className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-fe7007c"
                        data-id="fe7007c"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">

                          <div
                            className="elementor-element elementor-element-72e0a638 cmsmasters-color-variation-default cmsmasters-pointer-none cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-post-title cmsmasters-widget-title"
                            data-id="72e0a638"
                            data-element_type="widget"
                            data-widget_type="cmsmasters-post-title.default"
                          >
                            <div className="elementor-widget-container">
                              <h1 className="entry-title cmsmasters-widget-title__heading ">
                                {service.title}
                              </h1>{" "}
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-135ee2d3 cmsmasters-line-clamp-yes cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-post-excerpt cmsmasters-widget-short-text"
                            data-id="135ee2d3"
                            data-element_type="widget"
                            data-widget_type="cmsmasters-post-excerpt.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="entry-content">
                                <p>
                                  {service.subtitle}

                                </p>
                              </div>{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                  <section
                    className="elementor-section elementor-inner-section elementor-element elementor-element-3225a534 elementor-section-full_width elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                    data-id="3225a534"
                    data-element_type="section"
                  >
                    <div className="elementor-container elementor-column-gap-no">
                      <div
                        className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-40f0ef8f"
                        data-id="40f0ef8f"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-24f11528 cmsmasters-object-fit cmsmasters-object-fit-cover cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-post-featured-image cmsmasters-widget-image"
                            data-id="24f11528"
                            data-element_type="widget"
                            data-widget_type="cmsmasters-post-featured-image.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="cmsmasters-widget-image__wrap imghover" style={{ width: "800px", height: "680px" }}>
                                <img
                                  fetchpriority="high"
                                  width={"800px"}
                                  height={"500px"}
                                  src={service.image}
                                  style={{borderRadius:"20px"}}
                                  className="attachment-full size-full wp-image-7030 cmsmasters_img cmsmasters-lazyload lazyloaded"
                                  alt=""
                                  decoding="async"
                                  data-sizes="(max-width: 1920px) 100vw, 1920px"
                                  // data-src="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7.jpg"
                                  // data-srcset="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7.jpg 1920w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7-300x200.jpg 300w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7-1024x683.jpg 1024w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7-768x512.jpg 768w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7-1536x1024.jpg 1536w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7-450x300.jpg 450w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7-600x400.jpg 600w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7-30x20.jpg 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7-15x10.jpg 15w"
                                  sizes="(max-width: 1920px) 100vw, 1920px"
                                // srcSet="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7.jpg 1920w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7-300x200.jpg 300w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7-1024x683.jpg 1024w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7-768x512.jpg 768w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7-1536x1024.jpg 1536w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7-450x300.jpg 450w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7-600x400.jpg 600w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7-30x20.jpg 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/04/blog-7-15x10.jpg 15w"
                                />
                              </div>{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </section>
          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-7c45e7ed elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
            data-id="7c45e7ed"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-wide">
              <article
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-55db595"
                data-id="55db595"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="elementor-element elementor-element-769e406d cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-post-content cmsmasters-widget-content elementor-widget-theme-post-content"
                    data-id="769e406d"
                    data-element_type="widget"
                    data-widget_type="cmsmasters-post-content.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="entry-content">
                        <div
                          data-elementor-type="wp-post"
                          className="elementor elementor-1167"
                        >
                          <section
                            className="elementor-section elementor-top-section elementor-element elementor-element-c574905 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                            data-id="c574905"
                            data-element_type="section"
                            data-settings='{"background_background":"classic"}'
                          >
                            <div className="elementor-container elementor-column-gap-no">
                              <div
                                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-f2ac454"
                                data-id="f2ac454"
                                data-element_type="column"
                              >
                                <div className="elementor-widget-wrap elementor-element-populated e-swiper-container">
                                  <div
                                    className="elementor-element elementor-element-88c2fad cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-text-editor"
                                    data-id="88c2fad"
                                    data-element_type="widget"
                                    data-widget_type="text-editor.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <p>
                                        {service.description}
                                      </p>{" "}
                                    </div>
                                  </div>
                                  {service.whyChooseUs && service?.whyChooseUs.points && service.whyChooseUs.points.map(
                                    (point, index) => (<div key={index} >
                                      <div
                                        className="elementor-element elementor-element-73b4412 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                                        data-id="73b4412"
                                        data-element_type="widget"
                                        data-widget_type="heading.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <h3 className="elementor-heading-title elementor-size-default">
                                            {point.title}
                                          </h3>{" "}
                                        </div>
                                      </div>
                                      <div
                                        className="elementor-element elementor-element-f17f26d cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-text-editor"
                                        data-id="f17f26d"
                                        data-element_type="widget"
                                        data-widget_type="text-editor.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <p>
                                            {point.description}
                                          </p>
                                          <p>
                                            {point.descriptionsec}
                                          </p>{" "}
                                        </div>
                                      </div>
                                    </div>))}

                                  {/* <div
                                    className="elementor-element elementor-element-6826576 elementor-pagination-position-outside cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-image-carousel e-widget-swiper"
                                   
                                    data-element_type="widget"
                                    data-settings='{"slides_to_show":"1","navigation":"dots","autoplay":"yes","pause_on_hover":"yes","pause_on_interaction":"yes","autoplay_speed":5000,"infinite":"yes","effect":"slide","speed":500}'
                                    data-widget_type="image-carousel.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div
                                        className="elementor-image-carousel-wrapper swiper swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden"
                                        role="region"
                                        aria-roledescription="carousel"
                                        aria-label="Image Carousel"
                                        dir="ltr"
                                      >
                                        <div
                                          className="elementor-image-carousel swiper-wrapper"
                                          aria-live="off"
                                          style={{
                                            transform:
                                              "translate3d(-1600px, 0px, 0px)",
                                            transitionDuration: "0ms",
                                          }}
                                          id="swiper-wrapper-5bf9646321076a22f"
                                        >
                                          <div
                                            className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-next"
                                            role="group"
                                            aria-roledescription="slide"
                                            aria-label="3 / 3"
                                            data-swiper-slide-index={2}
                                            style={{ width: "800px" }}
                                            aria-hidden="true"
                                            inert
                                          >
                                            <figure className="swiper-slide-inner">
                                              <img
                                                decoding="async"
                                                className="swiper-slide-image cmsmasters_img cmsmasters-lazyload lazyautosizes ls-is-cached lazyloaded"
                                                src="/imges/new1.jpeg"
                                                alt="open-post-3"
                                                data-sizes="auto"
                                                // data-src="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-post-3.jpg"
                                                sizes="800px"
                                              />
                                            </figure>
                                          </div>
                                          <div
                                            className="swiper-slide swiper-slide-prev"
                                            role="group"
                                            aria-roledescription="slide"
                                            aria-label="1 / 3"
                                            data-swiper-slide-index={0}
                                            style={{ width: "800px" }}
                                            aria-hidden="true"
                                            inert
                                          >
                                            <figure className="swiper-slide-inner">
                                              <img
                                                decoding="async"
                                                className="swiper-slide-image cmsmasters_img cmsmasters-lazyload lazyautosizes lazyloaded"
                                                src="/imges/new1.jpeg"
                                                alt="open-post-2"
                                                data-sizes="auto"
                                                // data-src="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-post-2.jpg"
                                                sizes="800px"
                                              />
                                            </figure>
                                          </div>
                                          <div
                                            className="swiper-slide swiper-slide-active"
                                            role="group"
                                            aria-roledescription="slide"
                                            aria-label="2 / 3"
                                            data-swiper-slide-index={1}
                                            style={{ width: "800px" }}
                                          >
                                            <figure className="swiper-slide-inner">
                                              <img
                                                decoding="async"
                                                className="swiper-slide-image cmsmasters_img cmsmasters-lazyload lazyautosizes lazyloaded"
                                                src="/imges/new1.jpeg"
                                                alt="open-post-1"
                                                data-sizes="auto"
                                                // data-src="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-post-1.jpg"
                                                sizes="800px"
                                              />
                                            </figure>
                                          </div>
                                          <div
                                            className="swiper-slide swiper-slide-next"
                                            role="group"
                                            aria-roledescription="slide"
                                            aria-label="3 / 3"
                                            data-swiper-slide-index={2}
                                            style={{ width: "800px" }}
                                            aria-hidden="true"
                                            inert
                                          >
                                            <figure className="swiper-slide-inner">
                                              <img
                                                decoding="async"
                                                className="swiper-slide-image cmsmasters_img cmsmasters-lazyload lazyautosizes lazyloaded"
                                                src="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-post-3.jpg"
                                                alt="open-post-3"
                                                data-sizes="auto"
                                                data-src="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-post-3.jpg"
                                                sizes="800px"
                                              />
                                            </figure>
                                          </div>{" "}
                                          <div
                                            className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-prev"
                                            role="group"
                                            aria-roledescription="slide"
                                            aria-label="1 / 3"
                                            data-swiper-slide-index={0}
                                            style={{ width: "800px" }}
                                            aria-hidden="true"
                                            inert
                                          >
                                            <figure className="swiper-slide-inner">
                                              <img
                                                decoding="async"
                                                className="swiper-slide-image cmsmasters_img cmsmasters-lazyload lazyautosizes ls-is-cached lazyloaded"
                                                src="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-post-2.jpg"
                                                alt="open-post-2"
                                                data-sizes="auto"
                                                data-src="https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/open-post-2.jpg"
                                                sizes="800px"
                                              />
                                            </figure>
                                          </div>
                                        </div>
                                        <div className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal">
                                          <span
                                            className="swiper-pagination-bullet"
                                            role="button"
                                            data-bullet-index={0}
                                            aria-label="Go to slide 1"
                                          />
                                          <span
                                            className="swiper-pagination-bullet swiper-pagination-bullet-active"
                                            role="button"
                                            data-bullet-index={1}
                                            aria-label="Go to slide 2"
                                           
                                            aria-current="true"
                                          />
                                          <span
                                            className="swiper-pagination-bullet"
                                            role="button"
                                            data-bullet-index={2}
                                            aria-label="Go to slide 3"
                                          />
                                        </div>
                                        <span
                                          className="swiper-notification"
                                          aria-live="assertive"
                                          aria-atomic="true"
                                        />
                                      </div>
                                    </div>
                                  </div> */}
                                  {service.offerings!=null ? service.offerings.sections.map((item, index) => (<div key={index}>
                                    <div
                                    className="elementor-element elementor-element-c837799 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                                    data-id="c837799"
                                    data-element_type="widget"
                                    data-widget_type="heading.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <h3 className="elementor-heading-title elementor-size-default">
                                       {item.heading}
                                      </h3>{" "}
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-element elementor-element-dedc903 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-text-editor"
                                    data-id="dedc903"
                                    data-element_type="widget"
                                    data-widget_type="text-editor.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <p>
                                      {item.content}
                                      </p>
                                      <div
                                        className="elementor-element elementor-element-f3ab9f4 cmsmasters-widget-layout-row cmsmasters-widget-align-stretch cmsmasters-widget-direction-default cmsmasters-widget-marker-element-icon cmsmasters-widget-marker-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-icon-list cmsmasters-widget-icon-list"
                                        data-id="f3ab9f4"
                                        data-element_type="widget"
                                        data-widget_type="cmsmasters-icon-list.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <ul className="cmsmasters-widget-icon-list-items">
                                            {item.keyFeatures.map((keyitem,idx)=>(<li key={idx} className="cmsmasters-widget-icon-list-item active-icon-item">
                                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                                <span className="cmsmasters-widget-icon-list-item-icon">
                                                  <span>
                                                    <i
                                                      aria-hidden="true"
                                                      className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                                    ></i>
                                                  </span>
                                                </span>
                                                <span className="cmsmasters-widget-icon-list-item-text-inner">
                                                  <span className="cmsmasters-widget-icon-list-item-text">
                                                  {keyitem}
                                                  </span>
                                                </span>
                                              </span>
                                            </li>))}
                                          </ul>
                                        </div>
                                      </div>
                                      <p>
                                      {item.contentlast}
                                      </p>{" "}
                                    </div>
                                  </div>
                                  </div>)):null}
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>{" "}
                    </div>
                  </div>

                  <div
                    className="elementor-element elementor-element-2c2185b3 elementor-widget-cmsmasters-author-box_view_framed cmsmasters-align-center cmsmasters-layout-image-top cmsmasters-align-tablet-center cmsmasters-align-mobile-center cmsmasters-layout-image-tablet-top elementor-widget-cmsmasters-author-box__avatar_yes cmsmasters-layout-image-mobile-top cmsmasters-social-media-display-inline cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-author-box"
                    data-id="2c2185b3"
                    data-element_type="widget"
                    data-widget_type="cmsmasters-author-box.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-widget-cmsmasters-author-box__wrapper">
                        {/* <div className="elementor-widget-cmsmasters-author-box__avatar">
                          <img
                            src="https://secure.gravatar.com/avatar/cec22fb290043e2c1b9972d9bc2f0cfb?s=300&d=mm&r=g"
                            alt="cmsmasters"
                          />
                        </div> */}
                        <div className="elementor-widget-cmsmasters-author-box__text">
                          <h5 className="elementor-widget-cmsmasters-author-box__name">
                            Conclusion:{service.callToAction.title}
                          </h5>
                          <div className="elementor-widget-cmsmasters-author-box__bio">
                          {service.callToAction.content}<br/>{service.callToAction.buttonText}<br/>{service.callToAction.buttonLink}
                          </div>
                          <ul className="elementor-widget-cmsmasters-author-box__social-list">
                            <li
                              id="elementor-widget-cmsmasters-author-box__icon-item-facebook"
                              className="elementor-widget-cmsmasters-author-box__icon-item"
                            >
                              <a href="https://www.facebook.com/">
                                <i className="fab fa-facebook" />
                              </a>
                            </li>
                            <li
                              id="elementor-widget-cmsmasters-author-box__icon-item-pinterest"
                              className="elementor-widget-cmsmasters-author-box__icon-item"
                            >
                              <a href="https://www.pinterest.com/">
                                <i className="fab fa-pinterest" />
                              </a>
                            </li>
                            <li
                              id="elementor-widget-cmsmasters-author-box__icon-item-instagram"
                              className="elementor-widget-cmsmasters-author-box__icon-item"
                            >
                              <a href="https://www.instagram.com/">
                                <i className="fab fa-instagram" />
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>{" "}
                    </div>
                  </div>

                </div>
              </article>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
};

export default Insights;
